import { onMount, onDestroy } from '@/modules/_'

export default function (element, dataset) {
  const wrap = element
  const main = wrap.querySelector('.aeo-hero-form-w')
  const els = gsap.utils.toArray('.aeo-grid-el', wrap)

  const tl = gsap.timeline({
    defaults: {
      ease: 'power1.out',
      duration: 1,
    },
  })

  tl.from(main, {
    autoAlpha: 0,
    scale: 1.2,
  }).from(
    els,
    {
      autoAlpha: 0,
      scale: 1.05,
      yPercent: 100,
      stagger: {
        from: 'random',
        each: 0.05,
      },
    },
    '> -0.4'
  )
}
